module.exports = __webpack_public_path__ + "static/media/commenticon.994e8230.svg";